module.exports = {
	"articleTitle1": "Mosher-Jordan Hall, new Hill Dining Center show shift in campus ...",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "Mosher-Jordan Hall",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/news/university-invests-ongoing-housing-renovations",
	"articleSnippet1": "Sep 1, 2008 ... The dining center, the centerpiece of the newly renovated Mosher-Jordan \nResidence Hall, offers students “marketplace-style\" dining, with ...",
	"articleSnippet2": "Apr 2, 2015 ... West Quad Residential Hall's reopening in the fall will mark the end of the ... \nMosher-Jordan Residence Hall was the first large renovation ...",
	"totalMisc": 1,
	"articleTitle2": "Future of University housing renovations uncertain",
	"address": "200 Observatory St, Ann Arbor, MI, 48109",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/leg/imagecache/fullnode/cdz.NEW_.HillDiningCtr.09-22-2009.001.jpg",
			"author": "Veronica Menaldi",
			"caption": "Students eat at the Hill Dining Center on Tuesday, September 22, 2009."
		}
	],
	"position": {
		"lat": 42.279992,
		"lng": -83.731366
	},
	"tips": [
		{
			"text": "The mojo dining hall cookies are famous.",
			"person": "Erik Forkin"
		},
		{
			"text": "The grilled chicken breasts are surprisingly delicious and present every day, great for when the rest of Mojo lets you down.",
			"person": "Bob Lesser"
		},
		{
			"text": "Eat on the second floor for a much quieter experience, perfect for studying",
			"person": "Bob Lesser"
		},
		{
			"text": "Arguably the worst Pizza of any dining hall. Arguably",
			"person": "Bob Lesser"
		}
	],
	"bathroomrating": [
		{
			"rating": 4,
			"bathroom": "All Floors"
		}
	],
	"categories": {
		"dorm": 1,
		"misc": 1,
		"location": 1,
		"studyspot": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/mojo.json
// module id = 926
// module chunks = 0